import apiClient from './apiClient';

export async function listConsultants() {
  const { data } = await apiClient.get('/api/consultants');
  return data;
}

export async function createConsultant(payload) {
  const { data } = await apiClient.post('/api/admin/consultant', payload);
  return data;
}

export async function updateConsultant(id, payload) {
  const { data } = await apiClient.put(`/api/admin/consultant/${id}`, payload);
  return data;
}
